import { render } from "./review-result.vue?vue&type=template&id=2ce98266&scoped=true"
import script from "./review-result.vue?vue&type=script&lang=js"
export * from "./review-result.vue?vue&type=script&lang=js"

import "./review-result.vue?vue&type=style&index=0&id=2ce98266&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce98266"]])

export default __exports__